import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>
        <strong>Disclaimer:</strong> StreamSportsNow is an independent sports news and information portal created for marketing and editorial purposes.
        We are not affiliated with, sponsored by, or officially endorsed by any sports league or any streaming service.
        Any references to external streaming partners are for directional purposes only. Sports rights and event availability
        depend on your country and are subject to change. Always verify live fixtures, languages and plan details
        directly on the official provider website before subscribing or purchasing. We may earn a commission from qualifying
        purchases or sign-ups made through outbound links on this page.
      </p>
      <p><a href="https://www.awin1.com/cread.php?awinmid=126253&awinaffid=2941253&ued=https%3A%2F%2Fwww.dazn.com%2Fen-US%2Fwelcome
 ">Continue to Live Sports Partner →</a></p>
    </footer>
  );
};

export default Footer;
